import {Data, Int} from '@store/@types/util';
import {OrderedSet} from 'immutable';
import {InboxItemId} from 'records/InboxItem';

interface PaginatedResultsInterface {
  items: OrderedSet<InboxItemId>;
  page: Int;
  numPages?: Int;
}

export default class PaginatedResults extends Data<PaginatedResultsInterface>({
  items: OrderedSet(),
  page: 0,
  numPages: undefined,
}) {}
